import type { Reactive } from 'vue'

/**
 * The general system state, not related to a specific user request.
 * Typically the same throughout a single session.
 */
export type AppContext = {
  language: string
  languagePrefix: string | undefined
  currency: string
  salesOfficeCode: string | undefined
  partnerId: PartnerId | undefined
  persistentParams: object | undefined
  isFreeweek?: boolean | undefined
}

export function useAppContext(): Reactive<AppContext> {
  const params = useParams()
  const partner = usePartner()
  const confData = useConfdata()

  const isFreeweek = useFlag('freeweek')

  return reactive({
    language: confData.language,
    languagePrefix: computed(() => confData.languagePrefix),
    currency: computed(
      () => params.currency || partner.currency || confData.currency,
    ),
    salesOfficeCode: confData.salesoffice?.code,
    partnerId: computed(() => partner.id),
    persistentParams: computed(() => params.persistent),
    isFreeweek,
  })
}
